import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'filterOutSelectedEnclosures',
    standalone: false
})
export class FilterOutSelectedEnclosuresPipe implements PipeTransform {
  transform(bomModels: IBomModel[], selectedEnclosures: number[]): IBomModel[] {
    return bomModels?.filter(b => selectedEnclosures.includes(b.article.enclosureId));
  }
}
